import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import Shell from "@/components/Shell";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  return (
    <Shell footer={false}>
      <div className="max-w-lg mx-auto px-5 py-24 text-center" data-testid="payment-cancel">
        <XCircle className="text-muted-foreground mx-auto" size={48} />
        <h1 className="font-display text-4xl mt-6 text-foreground">Payment cancelled</h1>
        <p className="text-muted-foreground mt-2">No worries — nothing was charged. You can pick up where you left off.</p>
        <Link to="/explore" className="inline-block mt-8 rounded-full bg-accent text-accent-foreground px-6 py-3 font-semibold">Back to explore</Link>
      </div>
    </Shell>
  );
}
